import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { firstValueFrom } from 'rxjs';
import { CredentialService } from 'src/app/services/core/credential/credential.service';
import { UploadService } from 'src/app/services/core/documents/upload.service';
import { FundingSourceService } from 'src/app/services/core/funding-source/funding-source.service';
import { MemberService } from 'src/app/services/core/member/member.service';
import { RoleService } from 'src/app/services/core/role/role.service';
import { UserService } from 'src/app/services/core/users/user.service';
import { imageProcessing, ImageSnippet } from 'src/app/utils/image-processing-utils';
import { sweetAlert } from 'src/app/utils/swal';
import * as moment from 'moment-timezone';
import { timeZone } from 'src/app/utils/utils.common';
import { urls } from 'src/app/utils/url.utils';
import { CamelCasePipe } from 'src/app/pipes/camelcase.filter/camelcase.filter.pipe';
@UntilDestroy()

@Component({
  selector: 'app-add-user',
  templateUrl: './add-user.component.html',
  styleUrls: ['./add-user.component.css']
})
export class AddUserComponent implements OnInit {
  userForm!: FormGroup;
  showPassword = false;
  submitted = false;
  userId: any;
  companies: any;
  profileImageURL: string | null = null;
  selectedFile: ImageSnippet | null = null;
  roles:any = [];
  types: any = [ ];
  selectedRoleType:any
  fundingSources:any = [];
  members:any = [];
  controlName: string = '';
  timezones:any = moment.tz.names();
  constructor(
    private uploadService: UploadService,
    private credentialService: CredentialService,
    private userService: UserService,
    private router: Router,
    private route: ActivatedRoute,
    private fb: FormBuilder,
    private roleService: RoleService,
    private fundingSourceService: FundingSourceService,
    private memberService: MemberService,
  ) { }

  ngOnInit(): void {
    this.getCompanies();
    this.userForm = this.fb.group({
      name: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      password: ['', [Validators.required, Validators.minLength(8)]],
      role: [null, Validators.required],
      isActive: [true, Validators.required],
      profileImageURL: ['', Validators.required],
      company: [null],
      timeZone: [timeZone, Validators.required],
    });
    this.route.params.pipe(untilDestroyed(this)).subscribe((param) => {
      this.userId = param['userId'];
    });
    // if (this.userId) {
    //   this.getUserById();
    // }
    this.getRoles();
  }

  onInputChange(event: any) {
    if (this.userId) {
      const input = event.target.value;
      this.applyPasswordValidations(input);
    }
  }

  getRoles() {
    const queryparams = {
      limit: '999',
      page: '1',
    }
    this.roleService.getRoles(queryparams)
      .pipe(untilDestroyed(this)).subscribe((data: any) => {
        if (data && data.results) {
          // this.roles = data.results
          this.roles = data.results.map((item: any) => {
            return {
              ...item,
              name: new CamelCasePipe().transform(item.name)
            };
          });
        }
        if (this.userId) {
          this.getUserById();
        }
      })
  }
  

 async onRoleChange(selectedRoleId: any) {
    this.userForm.get('company')?.setValue(null);
    console.log(this.userForm.value)
    const selectedRole = this.roles.find((r: any) => r.id === selectedRoleId);
    this.selectedRoleType = selectedRole ? selectedRole.type : null;
    await this.patchRole();
  }

  async patchRole() {
    this.userForm.get('company')?.clearValidators();
     if (this.selectedRoleType === 'company') {
      this.types = await this.getCredentialCompanies();
      this.userForm.get('company')?.setValidators([Validators.required]);
    } 
    else {
      this.types = [];
    }
    // Update validity
    this.userForm.get('company')?.updateValueAndValidity();
  }

 


  async getCredentialCompanies(){
    const queryparams = {
      limit: 999,
      isActive : true
    }
    this.credentialService.getCompanies(queryparams)
      .pipe(untilDestroyed(this)).subscribe((data: any) => {
        if (data && data.results ) {
          return data
        }
      })
    const response: any = await firstValueFrom(
      this.credentialService.getCompanies(queryparams).pipe(untilDestroyed(this))
    );
    return response?.results || [];
  }
  


  onSave() {
    this.submitted = true;
   if (this.userForm.invalid) return;
  
    let payload = this.userForm.value;

    if (this.userId && !payload.password) {
      delete payload.password;
    }
    this.userService.saveUser(this.userId, payload).pipe(untilDestroyed(this)).subscribe(
      (data: any) => {
        if (data) {
          this.router.navigateByUrl(`/users`);
        }
      },
      (err) => {
        sweetAlert("Error", err, "error", "OK");
      }
    );
  }

  applyPasswordValidations(value: any) {
    const passwordControl = this.userForm.get('password');

    if (value) {
      passwordControl?.setValidators([Validators.required, Validators.minLength(8)]);
    } else {
      passwordControl?.clearValidators();
    }
    passwordControl?.updateValueAndValidity();
  }

  getUserById() {
    this.userService.getUserById(this.userId).pipe(untilDestroyed(this)).subscribe((data: any) => {
      if (data) {
        console.log("data",data)
        this.userForm.patchValue({
          ...data,
          role: data.role ? data.role.id : ''
        })
        this.selectedRoleType = this.roles.find((r: any) => r.id === data.role.id)?.type;

        console.log("selectedRoleType",this.selectedRoleType)
        this.profileImageURL = data.profileImageURL;
        // clear password validations
        this.userForm.get('password')?.clearValidators();
        this.userForm.get('password')?.updateValueAndValidity();
        if (this.selectedRoleType) {
          console.log("selectedRoleType",this.selectedRoleType)
           this.patchRole();
        }
       
      }
      
    })
  }

  togglePasswordVisibility() {
    this.showPassword = !this.showPassword;
  }

  getCompanies() {
    const queryparams = {
      limit: 999
    }
    this.credentialService.getPicker(queryparams)
      .pipe(untilDestroyed(this)).subscribe((data: any) => {
        if (data && data.results ) {
          this.companies = data.results;
        }
      })
  }

  processFile(imageInput: any) {
    const file = imageInput.files?.[0];
    if (file && file.size > 1024 * 1024) { // 1MB = 1024 * 1024 bytes
      sweetAlert('File too large', 'Please upload a file smaller than 1MB.', 'warning', 'OK');
      return;
    }
    imageProcessing(imageInput).pipe(untilDestroyed(this)).subscribe({
      next: (result) => {
        this.selectedFile = result.file;
        if (!this.selectedFile || !(this.selectedFile instanceof Blob)) {
          return;
        }
        this.uploadService.uploadImageToServer(this.selectedFile, urls.USERS).pipe(untilDestroyed(this)).subscribe({
          next: (uploadResult: any) => {
            if (uploadResult?.fileUrl) {
              this.userForm.get('profileImageURL')?.setValue(uploadResult.fileUrl);
              this.profileImageURL = uploadResult.fileUrl;
            }
          },
        });
      },
      error: (processingError) => {
        console.error('Error processing image:', processingError);
      },
    });
  }

  get form() {
    return this.userForm.controls;
  }
}
